import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketDetailVo} from '../../common/shared/api/nicolas/vo/TicketDetailVo.interface';

/**
 * 이용권 상세 정보 조회
 *
 * Origin: pageNicolasApi.getTicketDetails
 * API: POST /api/v1/store/coupon_history/details
 */
export async function postStoreCouponHistoryDetails(
  {
    ticketUid,
    seriesId,
  }: {
    ticketUid: string;
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<TicketDetailVo & ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/coupon_history/details',
    {
      method: 'POST',
      data: {
        ticketUid,
        seriesId,
      },
    },
    options
  );
  return response.data;
}
